import React from 'react';
import './style.scss';
import { FormattedMessage } from 'react-intl';
import { Line } from 'rc-progress';
import star from 'assets/imgs/star-gray.png';
import starMater from 'assets/imgs/star-orange.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/fontawesome-free-solid';

const MemberDetail = ({ item, index, removeItem, handleLimitData, isMaster, onlyData }) => {
  const phoneNumber = `0${item.msisdn?.slice(2)}`;
  const remainData = item.remain_volume;
  const totalData = item.total_volume;
  const remainCall = item.remain_volume_call;
  const totalCall = item.total_volume_call;

  const color = ['#A4EFC3', '#EA7086', '#8a77a3', '#14854d'];

  return (
    <div className="member-detail">
      <div className="d-none d-lg-block">
        <div className="member-detail__img" style={{ backgroundColor: `${color[index % 4]}` }}>
          {phoneNumber.slice(-3)}</div>
      </div>

      <div className="member-detail__slice">
        <div className="display-sb">
          <div className="member-detail__slice-item">
            <p style={{ fontWeight: 600 }} className="display-sb">
              <span><FormattedMessage id='IDS_TV_SO_DIEN_THOAI' /> {phoneNumber}</span>
              {!isMaster &&
                <FontAwesomeIcon
                  color="#C4C4C4"
                  icon={faTimesCircle}
                  size="lg"
                  className="pointer"
                  onClick={() => removeItem(item.msisdn)}
                />
              }
            </p>
            <Line
              percent={remainData / totalData * 100}
              strokeWidth={5}
              trailWidth={5}
              strokeColor={remainData !== 0 ? "#FF9A09" : "#fff"}
              trailColor="#E7E7E7"
            />
            <p style={{ textAlign: "left", fontSize: '12px' }}>
              <FormattedMessage id='IDS_REMAIN' />
              <span> {parseInt(remainData)}/{totalData} MB</span>
            </p>
          </div>
          {!isMaster &&
            <div className="member-detail__limit-data" onClick={() => handleLimitData(item, true)}>
              <FormattedMessage id='IDS_TV_GIOI_HAN_DATA' /></div>
          }
        </div>

        {!onlyData &&
          <div className="mt-3 display-sb">
            <div className="member-detail__slice-item">
              <Line
                percent={remainCall / totalCall * 100}
                strokeWidth={5}
                trailWidth={5}
                strokeColor={remainCall !== 0 ? "#FF9A09" : "#fff"}
                trailColor="#E7E7E7"
              />
              <p style={{ textAlign: "left", fontSize: '12px' }}>
                <FormattedMessage id='IDS_REMAIN' />
                <span> {parseInt(remainCall)}/{totalCall}</span>
                <FormattedMessage id='IDS_TV_NUMBER_PHUT' />
              </p>
            </div>
            {!isMaster &&
              <div className="member-detail__limit-data" onClick={() => handleLimitData(item)}>
                <FormattedMessage id='IDS_TV_GIOI_HAN_THOAI' /></div>
            }
          </div>
        }

      </div>
      <img alt="star" src={isMaster ? starMater : star} />
    </div>
  );
}

export default React.memo(MemberDetail);
